(() => {
  const initProduct = () => {
    const root = document.querySelector('[data-apex-product-detail]');
    if (!root || root.dataset.coV127Ready === 'true') return;
    const sticky = root.querySelector('[data-co-v127-sticky]');
    if (!sticky) return;
    root.dataset.coV127Ready = 'true';

    const stickyPrice = sticky.querySelector('[data-co-v127-sticky-price]');
    const stickyBuy = sticky.querySelector('[data-co-v127-sticky-buy]');
    const sourceBuy = () => root.querySelector('.co-product-buy-button-bottom');
    const sourcePrice = () => root.querySelector('[data-product-price]');

    const sync = event => {
      const variant = event?.detail?.variant;
      const primary = sourceBuy();
      if (stickyPrice) {
        if (variant?.price != null) {
          stickyPrice.textContent = new Intl.NumberFormat('es-CO', {
            style: 'currency', currency: 'COP', maximumFractionDigits: 0
          }).format(Number(variant.price) / 100);
        } else if (sourcePrice()) {
          stickyPrice.textContent = sourcePrice().textContent.trim().replace(/^Desde\s*/i, '');
        }
      }
      if (stickyBuy && primary) {
        stickyBuy.disabled = !!primary.disabled;
        stickyBuy.textContent = primary.disabled ? 'Agotado' : 'Comprar';
      }
    };

    stickyBuy?.addEventListener('click', () => {
      const primary = sourceBuy();
      if (!primary || primary.disabled) return;
      primary.click();
    });

    root.addEventListener('cyclooutlet:variant-change', sync);
    sync();

    const actions = root.querySelector('[data-product-actions-row]');
    if (actions && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio > .2);
        sticky.classList.toggle('is-suppressed', visible);
      }, { threshold: [0, .2, .5] });
      observer.observe(actions);
    }
  };

  const init = () => initProduct();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
